import { Chart as ChartJS, ArcElement, Title, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ArcElement, Title, Tooltip, Legend, ChartDataLabels);

const PieChart = ({
  data,
  options = {},
  height,
  showDataLabels = false,
  showLegend = true,
  ...props
}) => {
  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: showLegend,
        position: "bottom",
        labels: {
          usePointStyle: true,
          padding: 15,
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: false,
        text: "",
        font: {
          size: 16,
          weight: "bold",
        },
      },
      tooltip: {
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        titleColor: "#fff",
        bodyColor: "#fff",
        borderColor: "#ddd",
        borderWidth: 1,
        cornerRadius: 4,
        displayColors: true,
        callbacks: {
          label: function (context) {
            let label = context.label || "";
            if (label) {
              label += ": ";
            }
            if (context.parsed !== null) {
              const total = context.dataset.data.reduce((a, b) => a + b, 0);
              const percentage = ((context.parsed / total) * 100).toFixed(1);
              label += context.parsed.toLocaleString() + ` (${percentage}%)`;
            }
            return label;
          },
        },
      },
      datalabels: {
        display: showDataLabels,
        color: "#fff",
        font: {
          size: 11,
          weight: "bold",
        },
        formatter: (value, ctx) => {
          const total = ctx.dataset.data.reduce((a, b) => a + b, 0);
          const percentage = ((value / total) * 100).toFixed(1);
          return percentage > 5 ? `${percentage}%` : "";
        },
      },
    },
  };

  const processedData = {
    ...data,
    datasets: data.datasets.map((dataset) => ({
      ...dataset,
      borderWidth: 1,
      borderColor: "#fff",
    })),
  };

  const mergedOptions = {
    ...defaultOptions,
    ...options,
    plugins: {
      ...defaultOptions.plugins,
      ...options.plugins,
      legend: {
        ...defaultOptions.plugins.legend,
        ...options.plugins?.legend,
      },
      datalabels: {
        ...defaultOptions.plugins.datalabels,
        ...options.plugins?.datalabels,
      },
    },
  };

  return (
    <div style={{ height: height || "400px" }} {...props}>
      <Pie data={processedData} options={mergedOptions} />
    </div>
  );
};

export default PieChart;
